import dayjs from 'dayjs'
import { create } from 'zustand'

import { ConstructionSiteInterface, OrderStatusType } from '@/types'

interface ProfileStateInterface {
  currentTab: string

  searchQuery: string
  productQuery: string
  selectedStatus: OrderStatusType | 'ALL'
  dateFrom: dayjs.Dayjs | null
  dateTo: dayjs.Dayjs | null

  constructionSites: ConstructionSiteInterface['constructionSiteModel'][]
  updateConstructionSites: boolean | null

  setSearchQuery: (query: string) => void
  setProductQuery: (query: string) => void
  setSelectedStatus: (status: OrderStatusType | 'ALL') => void
  setDateFrom: (date: dayjs.Dayjs | null) => void
  setDateTo: (date: dayjs.Dayjs | null) => void

  setCurrentTab: (currentTab: string) => void
  setConstructionSites: (
    objects: ConstructionSiteInterface['constructionSiteModel'][]
  ) => void
  setUpdateConstructionSites: (updateObjects: boolean) => void
  setInitialProfileStore: () => void
}

const initialState = {
  currentTab: 'Заказы клиентов',
  searchQuery: '',
  productQuery: '',
  selectedStatus: 'ALL' as const,
  dateFrom: null as dayjs.Dayjs | null,
  dateTo: null as dayjs.Dayjs | null,
  constructionSites: [],
  updateConstructionSites: null,
}

export const useProfileStore = create<ProfileStateInterface>((set) => ({
  ...initialState,
  setCurrentTab: (currentTab: string) => {
    set(() => ({ currentTab }))
  },

  setSearchQuery: (searchQuery: string) => set({ searchQuery }),
  setProductQuery: (productQuery: string) => set({ productQuery }),
  setSelectedStatus: (selectedStatus: OrderStatusType | 'ALL') =>
    set({ selectedStatus }),
  setDateFrom: (dateFrom: dayjs.Dayjs | null) => set({ dateFrom }),
  setDateTo: (dateTo: dayjs.Dayjs | null) => set({ dateTo }),

  setConstructionSites: (
    constructionSites: ConstructionSiteInterface['constructionSiteModel'][]
  ) => {
    set(() => ({ constructionSites }))
  },
  setUpdateConstructionSites: (updateConstructionSites: boolean | null) => {
    set(() => ({ updateConstructionSites }))
  },
  setInitialProfileStore: () => {
    set(initialState)
  },
}))
